import { useMutation } from "@tanstack/react-query";
import { Link, useParams, useSearch } from "@tanstack/react-router";
import type { ReactElement } from "react";
import { MARKETPLACE_LABELS, isChannelProvider } from "@cx/domain";
import { ContentHeader } from "@cx/ui";
import { errorMessage } from "../../errors";
import { useSession } from "../../session";

/**
 * "Tela de autorização" do canal de testes (T3.3, só fora de produção). Autorizar devolve a query exata que o canal
 * mandaria ao redirect e segue para o mesmo retorno do canal real (navegação completa: a query vai intacta).
 */
export function ChannelSandboxConsentPage(): ReactElement {
  const { api } = useSession();
  const { provider } = useParams({ from: "/integracoes/canais/$provider/sandbox" });
  const { state } = useSearch({ from: "/integracoes/canais/$provider/sandbox" });
  const valid = isChannelProvider(provider);
  const label = valid ? MARKETPLACE_LABELS[provider] : "Canal";
  const authorize = useMutation({
    mutationFn: () =>
      api<{ query: string }>(`/marketplaces/channels/${provider}/sandbox/authorize`, {
        method: "POST",
        body: JSON.stringify({ state }),
      }),
    onSuccess: (r) => {
      window.location.replace(`/integracoes/canais/${provider}/retorno?${r.query}`);
    },
  });
  return (
    <>
      <ContentHeader
        title={`${label} de testes`}
        breadcrumb={["Preferências", "Integrações", "Canais", label]}
      />
      <div className="box card p-3" style={{ maxWidth: 560 }}>
        <p>
          O <strong>CX ERP</strong> quer acessar sua loja de testes: produtos, pedidos e estoque. Nenhuma loja
          real {valid ? `de ${label}` : ""} é usada.
        </p>
        {authorize.isError && <div className="alert alert-danger py-2">{errorMessage(authorize.error)}</div>}
        <div className="d-flex gap-2">
          <button
            type="button"
            className="btn btn-primary"
            disabled={!valid || !state || authorize.isPending}
            onClick={() => authorize.mutate()}
          >
            Autorizar
          </button>
          <a
            className="btn btn-outline-secondary"
            href={`/integracoes/canais/${encodeURIComponent(provider)}/retorno?error=access_denied`}
          >
            Recusar
          </a>
        </div>
        <p className="small text-muted mt-3 mb-0">
          <Link to="/preferencias/integracoes/canais">Voltar para os canais</Link>
        </p>
      </div>
    </>
  );
}
